import React from "react";
import PrepaidCardList from "./PrepaidCardList";

const PrepaidCards = () => {
  return (
    <div className="prepaid-cards-page-wrapper">
      <PrepaidCardList />
    </div>
  );
};

export default PrepaidCards;